var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1351_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 21.0876L4.62554 17.182C3.32812 15.3403 2.74743 13.0884 2.99243 10.8489C3.23743 8.6094 4.29129 6.53631 5.95623 5.01865C7.62117 3.501 9.78274 2.64311 12.0353 2.60599C14.2878 2.56888 16.4765 3.35508 18.1905 4.81705C19.9046 6.27903 21.0261 8.31628 21.3448 10.5465C21.6635 12.7767 21.1573 15.0465 19.9212 16.93C18.6852 18.8135 16.8043 20.1811 14.6315 20.7763C12.4587 21.3715 10.1434 21.1533 8.12003 20.1626L2.92969 21.0876Z",
    fill: "#E0BA56",
    stroke: "#E0BA56",
    strokeWidth: 1.29826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.84591C8 10.0091 8.06483 10.1656 8.18024 10.2811C8.29565 10.3965 8.45217 10.4613 8.61538 10.4613C8.77859 10.4613 8.93512 10.3965 9.05053 10.2811C9.16593 10.1656 9.23077 10.0091 9.23077 9.84591V8.61514C9.23077 8.45193 9.16593 8.2954 9.05053 8.18C8.93512 8.06459 8.77859 7.99976 8.61538 7.99976C8.45217 7.99976 8.29565 8.06459 8.18024 8.18C8.06483 8.2954 8 8.45193 8 8.61514V9.84591ZM8 9.84591C8 11.478 8.64835 13.0433 9.80242 14.1973C10.9565 15.3514 12.5217 15.9998 14.1538 15.9998M14.1538 15.9998H15.3846C15.5478 15.9998 15.7044 15.9349 15.8198 15.8195C15.9352 15.7041 16 15.5476 16 15.3844C16 15.2212 15.9352 15.0646 15.8198 14.9492C15.7044 14.8338 15.5478 14.769 15.3846 14.769H14.1538C13.9906 14.769 13.8341 14.8338 13.7187 14.9492C13.6033 15.0646 13.5385 15.2212 13.5385 15.3844C13.5385 15.5476 13.6033 15.7041 13.7187 15.8195C13.8341 15.9349 13.9906 15.9998 14.1538 15.9998Z",
    stroke: "#191718",
    strokeWidth: 1.29826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1351_3541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.667,
    height: 24.667,
    fill: "white",
    transform: "translate(0.332031 0.332764)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefono);
export default __webpack_public_path__ + "static/media/Telefono.c17e47833593c9c3afe70233523134ab.svg";
export { ForwardRef as ReactComponent };